import React from 'react'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@duck/ui'
import { useTar } from '@/modules/i18n'

interface CompletionRingProps {
  submitted: number
  total: number
}

export const CompletionRing: React.FC<CompletionRingProps> = ({ submitted, total }) => {
  const { t } = useTar()
  const rate = total > 0 ? submitted / total : 0
  const circumference = 2 * Math.PI * 10 // r=10
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex items-center gap-1.5">
            <svg width="24" height="24" viewBox="0 0 24 24" className="-rotate-90" aria-hidden="true">
              <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="4" className="text-muted/30" />
              <circle
                cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="4"
                strokeDasharray={`${rate * circumference} ${circumference}`}
                strokeLinecap="round" className="text-primary"
              />
            </svg>
            <span className="text-xs text-foreground">{submitted}/{total}</span>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          {Math.round(rate * 100)}% {t('partner.completionRate').toLowerCase()}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
